import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import { isFase2Ativa } from '../../utils/fase';
import { useGlobal } from '../../contexts/global';

const getAbaNome = (key, abas = {}) => {
  if (abas[key]) return abas[key];
  const cleanedKey = key.trim().replace(/[_-\s]+$/, '');
  if (abas[cleanedKey]) return abas[cleanedKey];
  const underKey = cleanedKey.replace(/-/g, '_');
  if (abas[underKey]) return abas[underKey];
  const dashKey = cleanedKey.replace(/_/g, '-');
  if (abas[dashKey]) return abas[dashKey];
  return key.replace(/_/g, ' ').replace(/-/g, ' ').toUpperCase();
};

const PadariasFase2 = ({ padarias, abas, cidade }) => {
  const {
    setIdPadaria,
    setNomePadaria,
    setZonaAtual,
    setShowModalVotacao,
    activeTabKey,
    setActiveTabKey
  } = useGlobal();
  const fase2Ativa = isFase2Ativa(cidade);

  const basePath =
    cidade?.pagina || (cidade?.slug ? `/${cidade.slug}` : '/sao-paulo');

  const showVotacao = (id, nome, zona) => {
    setIdPadaria(id);
    setNomePadaria(nome);
    setZonaAtual(zona);
    setShowModalVotacao(true);
  };

  const tabKeys = Object.keys(padarias);

  const normalizeKey = (key) =>
    (key || '')
      .toString()
      .toLowerCase()
      .trim()
      .replace(/[-_\s]+/g, '');

  const selectedIndex = React.useMemo(() => {
    if (!activeTabKey) return 0;
    const index = tabKeys.findIndex(
      (k) => normalizeKey(k) === normalizeKey(activeTabKey)
    );
    return index >= 0 ? index : 0;
  }, [tabKeys, activeTabKey]);

  if (tabKeys.length === 0) return null;

  return (
    <div className="in-step-ctn-grid-ctt-cards" id="padarias">
      <Tabs
        selectedIndex={selectedIndex}
        onSelect={(index) => {
          if (tabKeys[index] && setActiveTabKey) {
            setActiveTabKey(tabKeys[index]);
          }
        }}
      >
        <TabList>
          {tabKeys.map((key) => {
            const nomeAba = getAbaNome(key, abas);
            const isLongName = nomeAba.length > 21;
            return (
              <Tab
                key={key}
                data-tab-key={key}
                data-tab-key-clean={normalizeKey(key)}
                className={`react-tabs__tab ${
                  isLongName ? 'react-tabs__tab--full' : ''
                }`}
              >
                {nomeAba}
              </Tab>
            );
          })}
        </TabList>
        {tabKeys.map((key) => {
          const nomeAba = getAbaNome(key, abas);
          return (
            <TabPanel key={key}>
              <ul>
                {padarias[key]?.map((item) => (
                  <li key={item.id}>
                    <div className="in-step-ctn-grid-ctt-cards-flip">
                      <div className="in-step-ctn-grid-ctt-cards-flip-front">
                        <img src={item.imagem} alt={item.nome} />
                        <div>
                          <p>{item.nome}</p>
                          {fase2Ativa && (
                            <span
                              onClick={() =>
                                showVotacao(item.id, item.nome, nomeAba)
                              }
                              role="button"
                              tabIndex={0}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  showVotacao(item.id, item.nome, nomeAba);
                                }
                              }}
                            >
                              Vote agora!
                            </span>
                          )}
                          <Link to={`${basePath}/padaria/${item.slug}`}>
                            <span>ver detalhes</span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </TabPanel>
          );
        })}
      </Tabs>
    </div>
  );
};

PadariasFase2.propTypes = {
  padarias: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
          .isRequired,
        nome: PropTypes.string.isRequired,
        imagem: PropTypes.string,
        slug: PropTypes.string.isRequired
      })
    )
  ).isRequired,
  abas: PropTypes.objectOf(PropTypes.string).isRequired,
  cidade: PropTypes.shape({
    slug: PropTypes.string,
    pagina: PropTypes.string
  })
};

PadariasFase2.defaultProps = {
  cidade: null
};

export default PadariasFase2;
